import '../styles/channelStyles.css'
import '../styles/channelLayoutStyles.css'
import { Button } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { API } from 'aws-amplify'
import React, { useState, useEffect } from 'react';
import {
  Table,
  TableCell,
  TableBody,
  TableHead,
  TableRow,
  ThemeProvider,
} from '@aws-amplify/ui-react';
import {ChannelIcons, crawlText} from '../utils/constants.js';
import {getVideoPlayerUrl} from '../utils/helpers.js';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { TextAreaField } from '@aws-amplify/ui-react';
import AddAction from '../components/addAction';
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import VideoPlayer from '../components/videoPlayer.js';
import VideoPlayerHls from '../components/videoPlayerHls.js';

// API vars
const myAPI = "api94d03d7c"
const dotOnPath = "/blue-dot-on"
const dotOffPath = "/blue-dot-off"
const scheduleActionsPath = "/get-actions"
const deleteActionPath = "/delete-schedule-action"
const crawlPath = "/get-crawl-text"
const crawlAddTextPath = "/add-crawl-text"
const manualCrawlRunPath = "/manual-crawl-run"

// Custom Themes
const theme = {
  name: 'table-theme',
  tokens: {
    components: {
      table: {
        row: {
          hover: {
            backgroundColor: { value: '{colors.brand.secondary[60]}' },
          },
        },
      },
    },
  },
  name: 'button-theme',
  tokens: {
    colors: {
      border: {
        primary: { value: 'black' },
      },
    },
    components: {
      button: {
        backgroundColor: { value: "#6a5acd" },
      },
    },     
  },
};

export default function ChannelLayout (props) {
  
  // State vars
  const [blueDotSliderChecked, setblueDotSliderChecked] = useState(false);
  const [channelActions, setChannelActions] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [crawlMessage, setCrawlMessage] = useState("");
  const [crawlSubmission, setCrawlSubmission] = useState("");

  // Additional vars

  const playerUrl = getVideoPlayerUrl(props.channel);
  let videoPlayerChannelName = "";
  // Modify channel name to exclude hyphen when used in video player component
  if(props.channel.includes("-")) {
    videoPlayerChannelName = props.channel.replace("-", "");
    console.log(videoPlayerChannelName);
  }
  else {
    videoPlayerChannelName = props.channel;
  }

  // API Functions
  
  // Blue dot changes
  function blueDotChange(e) {
    setblueDotSliderChecked(e.target.checked);
  }

  useEffect(() => {
    const event_body = {
      "body": {
        "channel": props.channel.toUpperCase()
      }
    }
    if(blueDotSliderChecked) {
      API.post(myAPI, dotOnPath, event_body)
        .then(response => {
          console.log(response)
        })
        .catch(error => {
          console.log(error)
        })
    }
    else {
      API.post(myAPI, dotOffPath, event_body)
      .then(response => {
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
    }
  }, [blueDotSliderChecked])

// Schedule action changes
  function getScheduleActionsInit() {
    const event_body = {
      queryStringParameters: {
        channel: props.channel.toUpperCase() 
      }
    };
    API.post(myAPI, scheduleActionsPath, event_body)
      .then(response => {
        setChannelActions(response)
      })
      .catch(error => {
        console.log(error)
      })
  }
  useEffect(() => {
    getScheduleActionsInit();
  }, []);

  // Get initial crawl text
  function getCrawlTextInit() {
    const event_body = {
      "body": {
        "channel": props.channel.toUpperCase(),
        "subCompositionName": "Ticker"
      }
    };
    API.post(myAPI, crawlPath, event_body)
      .then(response => {
        console.log(response)
        setCrawlMessage(response)
      })
      .catch(error => {
        console.log(error)
      })
  }
  useEffect(() => {
    getCrawlTextInit();
  }, []);

  // Update crawl text

  function updateCrawlText(message) {
    const event_body = {
      "body": {
        "channel": props.channel.toUpperCase(),
        "message": crawlSubmission,
        "subCompositionName": "Ticker"
      }
    };
    API.post(myAPI, crawlAddTextPath, event_body)
      .then(response => {
        console.log(response)
        setCrawlMessage(response)
      })
      .catch(error => {
        console.log(error)
      })
  }

  useEffect(() => {
    getCrawlTextInit();
  }, [crawlMessage]);

  // Delete schedule actions

  function handleDelete(action_name) {
    const event_body_del = {
      "body": {
        "channel": props.channel.toUpperCase(),
        "delete_action_name": action_name
      }
    }
    const event_body_get = {
      "body": {
        "channel": props.channel.toUpperCase()
      }
    }
    API.del(myAPI, deleteActionPath, event_body_del)
      .then(response => {
        console.log(response)
        if(response.statusCode === 200) {
          toast.success("Successfully deleted action")
        }
      })
      .catch(error => {
        console.log(error)
        toast.error("Error deleting action")
      })
      const event_body = {
        queryStringParameters: {
          channel: props.channel.toUpperCase()
        }
      };
    // After delete, get updated schedule actions
    API.post(myAPI, scheduleActionsPath, event_body_get)
      .then(response => {
        console.log(response)
        setChannelActions(response)
      })
      .catch(error => {
        console.log(error)
      })
  }

  useEffect(() => {
    getScheduleActionsInit();
  }, [channelActions]);


  // Manually run a crawl
  function manualCrawlRun() {
    const event_body = {
      "body": {
        "channel": props.channel.toUpperCase(),
        "subCompositionName": "Ticker"
      }
    };
    API.post(myAPI, manualCrawlRunPath, event_body)
      .then(response => {
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  }

  return (
    <div>
        <div className="page-container">
            <div className="label-box">
                <span className="border-title">{props.channel}</span>
                <div className="page-split">
                    <div> 
                    <VideoPlayer channelName={videoPlayerChannelName} isMultiViewer={false} videoURL={playerUrl} />
                    </div>
                    <div className="schedule-table">
                        <p className="schedule-title">Channel Schedule</p>
                        <ThemeProvider theme={theme} colorMode="light">
                        <Table
                            caption=""
                            highlightOnHover={true}>
                            <TableHead>
                            <TableRow>
                                <TableCell as="th">ID</TableCell>
                                <TableCell as="th">Action Name</TableCell>
                                <TableCell as="th">Action Type</TableCell>
                                <TableCell as="th">Start Time</TableCell>
                                <TableCell></TableCell>
                            </TableRow>              
                            </TableHead>
                            <TableBody>
                            {channelActions.map((action) => (
                                <TableRow>
                                <TableCell>{action.id}</TableCell>
                                <TableCell>{action.action_name}</TableCell>
                                <TableCell>{action.action_type}</TableCell>
                                <TableCell>{action.start_time}</TableCell>
                                <TableCell> 
                                    <Button onClick={() => handleDelete(action.action_name)}>
                                    <HighlightOffIcon/> 
                                    </Button>
                                </TableCell>
                                </TableRow>          
                            ))}
                            </TableBody>
                        </Table>
                        <AddAction 
                            channel={props.channel}
                            // channel={props.channel.toUpperCase()}
                            currentActions={channelActions}/>
                        </ThemeProvider>
                    </div>
                </div>
                <div className="bottom">
                    <div className="left-side-bottom">
                    <ThemeProvider theme={theme}>
                        <div className="bluedot-position" >
                            <FormGroup >
                                <FormControlLabel control={
                                <Switch 
                                    color="secondary" 
                                    onChange={blueDotChange}/>} label="Blue Dot Test" />
                            </FormGroup>
                            </div>
                        <p className="schedule-title">Crawl Text</p>
                        <TextAreaField
                        className="crawl-text-area"
                        descriptiveText="Enter the updated crawl text."
                        placeholder={crawlMessage}
                        rows={5}
                        onChange={e => setCrawlSubmission(e.target.value)}/>
                        <div className='crawl-button-bar'>
                            <div className="crawl-button">
                            <Button className="crawl-button-design" onClick={() => updateCrawlText(crawlSubmission)}>
                                Update Text
                            </Button>
                            </div>
                            <div className="crawl-button">
                            <Button className="crawl-button-design" onClick={() => manualCrawlRun()}>
                                Manually Run Crawl
                            </Button>
                            </div>
                        </div>
                    </ThemeProvider>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}
